export default __webpack_public_path__ + "static/media/home_icon_cost.c7553fb2.png";